// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResultLink.scss
// module id = 535
// module chunks = 0 12 18 21 23 27 28 30 42 88